import React from 'react';
import * as yup from 'yup';
import { SparkForm } from 'sharedComponents/SparkForm';
import StepReferenceTextField from '../StepReferenceTextField';
import SparkSettingsFooter from './SparkBuilderSettingsFiles/SparkSettingsFooter';
import { useSparkBuilderStore } from 'stores';
import { useUpdateSpark } from 'hooks/spark';

export type SparkBuilderConfigureOutputType = {
  output: string;
};

function SparkBuilderConfigureOutput() {
  const joinedSpark = useSparkBuilderStore(
    React.useCallback((store) => store.joinedSpark, [])
  );
  const { mutateAsync: updateSpark } = useUpdateSpark(joinedSpark?.id);
  const validationSchema = yup.object().shape({
    output: yup
      .string()
      .required('JSON Output is required')
      .test('json', 'Invalid JSON format', (value) => {
        try {
          const stringValue = JSON.stringify(value);
          const output = JSON.parse(JSON.parse(stringValue));
          if (!output || typeof output !== 'object' || Array.isArray(output)) {
            return false;
          }
          return true;
        } catch (error) {
          return false;
        }
      }),
  });

  const initialValues: SparkBuilderConfigureOutputType = {
    output: joinedSpark?.attributes.output || '',
  };

  const handleSubmit = (values: SparkBuilderConfigureOutputType) => {
    updateSpark({ output: values.output });
  };

  return (
    <SparkForm
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSave={handleSubmit}
      sx={{
        paddingX: '2px',
        position: 'relative',
        alignContent: 'space-between',
        paddingTop: 2,
      }}
    >
      <StepReferenceTextField
        name='output'
        label='JSON Output'
        isMultiline={true}
        placeholder='{"key": "value"}'
      />
      <SparkSettingsFooter primaryButtonText='Save' />
    </SparkForm>
  );
}

export default SparkBuilderConfigureOutput;
